/**
 * Native size chart + size calculator (replaces the Kiwi Size Chart app).
 *
 * The theme's global modal CLONES the size chart content into the modal on
 * open, so all interactivity is bound through document-level event delegation
 * rather than direct element listeners.
 */
(function () {
  if (window.__sizeChartInit) return;
  window.__sizeChartInit = true;

  var PREF_SHIFT = { slim: -0.33, loose: 0.33 };

  function parseCalcData(calculator) {
    var script = calculator.querySelector('[data-size-chart-calc-data]');
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  // Continuous size index: the size whose measurement band contains the
  // value, interpolating linearly across gaps between adjacent bands.
  function fieldSizeIndex(m, field) {
    var ranges = field.ranges;
    var last = ranges.length - 1;
    if (m <= ranges[0][1]) return 0;
    if (m >= ranges[last][0]) return last;
    for (var i = 0; i < last; i++) {
      if (m >= ranges[i][0] && m <= ranges[i][1]) return i;
      if (m > ranges[i][1] && m < ranges[i + 1][0]) {
        return i + (m - ranges[i][1]) / (ranges[i + 1][0] - ranges[i][1]);
      }
    }
    return last;
  }

  function isConstantField(field) {
    var first = field.ranges[0];
    return field.ranges.every(function (r) {
      return r[0] === first[0] && r[1] === first[1];
    });
  }

  // 0% = tight (left), 100% = loose (right), 50% = ideal fit.
  function meterPosition(m, field, sizeIndex) {
    var lo = field.ranges[sizeIndex][0];
    var hi = field.ranges[sizeIndex][1];
    var mid = (lo + hi) / 2;
    var allowance = Math.max((hi - lo) / 2, mid * field.stretch, 1);
    var delta = (m - mid) / allowance;
    delta = Math.max(-1, Math.min(1, delta));
    return 50 - 50 * delta;
  }

  function renderMeters(calculator, data, provided, sizeIndex) {
    var wrap = calculator.querySelector('[data-size-chart-meters]');
    var tight = wrap.getAttribute('data-lang-tight') || 'Tight';
    var loose = wrap.getAttribute('data-lang-loose') || 'Loose';
    wrap.textContent = '';

    provided.forEach(function (p) {
      var field = data.fields[p.index];
      var pos = meterPosition(p.value, field, sizeIndex);

      var meter = document.createElement('div');
      meter.className = 'size-chart__meter';

      var label = document.createElement('div');
      label.className = 'size-chart__meter-label';
      label.textContent = field.label;

      var track = document.createElement('div');
      track.className = 'size-chart__meter-track';

      var ends = document.createElement('div');
      ends.className = 'size-chart__meter-ends';
      var tightEnd = document.createElement('span');
      tightEnd.textContent = tight;
      var looseEnd = document.createElement('span');
      looseEnd.textContent = loose;
      ends.appendChild(tightEnd);
      ends.appendChild(looseEnd);

      var arrow = document.createElement('span');
      arrow.className = 'size-chart__meter-arrow';
      arrow.style.left = pos + '%';
      track.appendChild(arrow);

      meter.appendChild(label);
      meter.appendChild(track);
      meter.appendChild(ends);
      wrap.appendChild(meter);
    });
  }

  function updateTriggerLabel(root, text) {
    var blockId = root.getAttribute('data-block-id');
    var block = document.querySelector(
      '[data-size-chart-block][data-block-id="' + blockId + '"] [data-size-chart-reco]'
    );
    if (block) block.textContent = text;
  }

  function recompute(calculator) {
    var data = parseCalcData(calculator);
    if (!data) return;

    var root = calculator.closest('[data-size-chart]');
    var result = calculator.querySelector('[data-size-chart-result]');
    var fitSelect = calculator.querySelector('[data-size-chart-fit]');
    var inputs = calculator.querySelectorAll('[data-size-chart-field]');

    var provided = [];
    inputs.forEach(function (input) {
      var value = parseFloat(String(input.value).replace(',', '.'));
      if (isFinite(value) && value > 0) {
        provided.push({ index: parseInt(input.getAttribute('data-size-chart-field'), 10), value: value });
      }
    });

    // Constant columns (same value for every size) carry no sizing signal.
    var signal = provided.filter(function (p) {
      return !isConstantField(data.fields[p.index]);
    });

    if (!signal.length) {
      result.hidden = true;
      if (root) updateTriggerLabel(root, root.getAttribute('data-lang-whats-my-size'));
      return;
    }

    var sum = 0;
    signal.forEach(function (p) {
      sum += fieldSizeIndex(p.value, data.fields[p.index]);
    });
    var avg = sum / signal.length;

    var pref = fitSelect ? fitSelect.value : '';
    avg += PREF_SHIFT[pref] || 0;

    var sizeIndex = Math.round(avg);
    sizeIndex = Math.max(0, Math.min(data.sizes.length - 1, sizeIndex));
    var sizeName = data.sizes[sizeIndex];

    result.hidden = false;
    calculator.querySelector('[data-size-chart-result-size]').textContent = sizeName;
    renderMeters(calculator, data, provided, sizeIndex);

    if (root) {
      updateTriggerLabel(root, root.getAttribute('data-lang-reco-short') + ' ' + sizeName);
    }
  }

  function switchTab(tab) {
    var root = tab.closest('[data-size-chart]');
    if (!root) return;
    var key = tab.getAttribute('data-size-chart-tab');

    root.querySelectorAll('[data-size-chart-tab]').forEach(function (t) {
      var active = t === tab;
      t.classList.toggle('active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-size-chart-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-size-chart-panel') !== key;
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-size-chart-tab]');
    if (tab) switchTab(tab);
  });

  function onFieldEvent(e) {
    if (!e.target.closest) return;
    if (!e.target.matches('[data-size-chart-field], [data-size-chart-fit]')) return;
    var calculator = e.target.closest('[data-size-chart-calculator]');
    if (calculator) recompute(calculator);
  }

  document.addEventListener('input', onFieldEvent);
  document.addEventListener('change', onFieldEvent);
})();
